import React from 'react';
import Guidelist from './GuideList';
import Timeline from './Timeline';
import { sendEvent } from '../../utils';

interface IStickyListProps {
  title: string;
  description: string;
  list: string[];
  currentBoxIndex: number;
  ctaContent: string;
  ctaTracking?: string;
  ctaLink?: string;
  isMobile?: boolean;
  showCta?: boolean;
  showHeader?: boolean;
}

const Stickylist = ({
                      title,
                      description,
                      list,
                      currentBoxIndex,
                      ctaContent,
                      ctaTracking,
                      ctaLink,
                      isMobile = false,
                      showCta = true,
                      showHeader = true
                    }: IStickyListProps) => {
  return (
    <div className={`wallet-guide-inner__right ${isMobile ? 'mobile' : 'desktop'}`}>
      {showHeader && (
        <React.Fragment>
          <h3 className='title'>{title}</h3>
          <p className='subtitle'>{description}</p>
        </React.Fragment>
      )}
      <ul className='guide-stage-list'>
        <Timeline currentIndex={currentBoxIndex} />
        {list.map((item, index) => (
          <Guidelist
            key={`guideList_${index}`}
            index={index}
            content={item}
            active={currentBoxIndex >= index}
          />
        ))}
      </ul>
      {showCta && (
        <div className='cta-wrapper'>
          <a
            href={ctaLink}
            className='btn btn__secondary'
            data-alt-text={ctaContent}
            onClick={() => sendEvent(ctaTracking)}
          >
            <span>{ctaContent}</span>
          </a>
        </div>
      )}
    </div>
  );
};

export default Stickylist;
